<!--
Copyright (c) 2020 GanttProject Cloud OU.
Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
-->
<template>
<div class="col-md-6 pl-md-4" id="team-list">
    <div class="header">
        <h4>My Teams</h4>
    </div>
    <div class="d-flex flex-wrap" id="teams-tab-row">
        <ul class="nav nav-pills flex-nowrap flex-grow-1 pb-2" role="tablist" id="nav-teams">
            <li class="nav-item">
                <a class="nav-link active" href="#team-own" id="tab-team-own"
                   data-toggle="pill"
                   aria-controls="team-own" aria-selected="true"
                   v-on:click="switchToOwnSelectionModel">Owner</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#team-member" id="tab-team-member"
                   data-toggle="pill"
                   aria-controls="team-member" aria-selected="false"
                   v-on:click="switchToMemberSelectionModel">Member</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#team-invite" id="tab-team-invite"
                   data-toggle="pill"
                   aria-controls="team-invite" aria-selected="false"
                   v-on:click="switchToInviteSelectionModel">Invited</a>
            </li>
        </ul>
        <div class="flex-wrap d-flex align-items-baseline" style="flex: 1">
            <button type="button" role="button" data-toggle="modal" data-target="#modal-new-team"
                    class="btn btn-attention btn-new-item pull-right w-100"
                    id="btn-new-team">
                New Team
            </button>
        </div>
    </div>
    <!-- TODO: add template for panes -->
    <div class="d-flex pt-3">
      <div id="teams-all" class="tab-content">
          <div class="tab-pane fade show active"
                 id="team-own" role="tabpanel" aria-labelledby="tab-team-own">
              <div v-if="hasOwnedTeams" v-bind:class="{'d-block': hasOwnedTeams, 'd-none': !hasOwnedTeams}">
                    <div class="list-group" id="team-own-list">
                        <a href="javascript:void(0)"
                           class="list-group-item list-group-item-action flex-column align-items-start"
                           v-for="t in ownedTeams"
                           v-bind:key="t.refid"
                           v-bind="{'data-team': t.refid}">
                            <div class="d-flex w-100">
                                <div class="team-left">
                                    <div class="d-flex w-100 justify-content-between">
                                        <h5 class="mb-1">{{t.name}}</h5>
                                    </div>
                                    <p class="mb-1">{{t.description}}</p>
                                    <small v-if="t.budget">Charges this month: {{t.budget.charges}}/{{t.budget.monthlyLimit}}</small>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="list-group tab-pane fade" id="team-member"
                 role="tabpanel" aria-labelledby="tab-team-member">
                <a href="javascript:void(0)"
                   class="list-group-item list-group-item-action flex-column align-items-start"
                   v-for="t in fellowTeams"
                   v-bind:key="t.refid"
                   v-bind="{'data-team': t.refid}"
                >
                    <div class="d-flex w-100">
                        <div class="team-left p-2">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1">{{t.name}}</h5>
                            </div>
                            <p class="mb-1">{{t.description}}</p>
                            <small></small>
                        </div>
                        <div class="team-right p-2">
                            <button id="leave-team-button"
                                    data-toggle="modal"
                                    data-target="#modal-leave-team"
                                    class="btn btn-remove-team btn-menu btn-outline-secondary"
                                    v-show="!isOwnedTeam(t.refid)"
                                    title="Leave this team">
                                <i class="fas fa-sign-out-alt"></i>
                            </button>
                        </div>
                    </div>
                </a>
            </div>
            <div class="list-group tab-pane fade" id="team-invite"
                 role="tabpanel" aria-labelledby="tab-team-invite">
                <a href="javascript:void(0)"
                   class="list-group-item list-group-item-action flex-column align-items-start team-list-item"
                   v-for="ivt in openInvites"
                   v-bind="{'data-invite': ivt.code}"
                >
                    <div class="d-flex w-100 justify-content-center align-items-center">
                        <i class="fa fa-3x fa-users" v-bind:title="ivt.team.description"></i>
                        <i class="fa fa-2x fa-plus ml-2 mr-2"></i>
                        <i class="fa fa-3x fa-user"></i>
                    </div>
                    <div class="d-flex w-100 justify-content-center mt-2 mb-3">
                        <div class="text-center">
                            <p>You're invited to join the team {{ivt.team.name}}!
                            </p>
                        </div>
                    </div>
                    <div class="d-flex w-100 justify-content-center">
                        <button class="btn btn-attention mr-1" v-on:click="joinTeam(ivt.code)">Accept</button>
                        <button class="btn btn-secondary ml-1"  v-on:click="cancelInvitation(ivt.code)">Decline</button>
                    </div>
                </a>
                <div class="text-center" v-show="openInvites.length === 0">
                    <i class="fa fa-10x fa-ban mt-5 mb-2"></i><br>
                    <p class="text-muted text-center">It is empty here. You have no open invitations. What about creating your own team?<br>
                        <a href="https://help.ganttproject.biz/t/inviting-collaborators" target="_blank">Learn more</a></p>
                </div>
            </div>
        </div>
    </div>
    <div class="justify-content-center" v-show="hasHelpCard">
        <div class="text-center">
            <i class="fa fa-10x fa-users mt-5 mb-2"></i><br>
            <button type="button" role="button"
                    data-toggle="modal" data-target="#modal-new-team"
                    class="btn btn-attention btn-new-item fa-2x" id="btn-new-team">
                Create New Team
            </button>
        </div>
    </div>
    <div class="mt-3 justify-content-center" v-show="hasHelpCard">
        <p class="text-muted text-center">Team is a group of people working on the same projects.<br>
            <a href="https://help.ganttproject.biz/t/what-is-a-team-in-ganttproject-cloud" target="_blank">Learn more</a></p>
    </div>

    <TeamNewModal :dashboard-refresh="onNewTeamDashboardRefresh"></TeamNewModal>
    <TeamLeaveModal :dashboard-refresh="showFellowTeams"
                    :team="team">
    </TeamLeaveModal>
</div>
</template>

<script lang="ts">
import {Component, Vue, toNative} from 'vue-facing-decorator';
import TeamNewModal from './TeamNewModal.vue';
import {
  BUDGET_DEFAULT,
  BudgetDto,
  InviteDto,
  loadOpenInvites,
  loadOwnedTeams,
  loadParticipatedTeams,
  TeamDto
} from '@/Teams';
import {TeamLists, updateDependencies} from '@/Dashboard';
import {handleXhrError, ModelSwitch, SelectionModel} from '@/utils/Ui';
import {CancelInvite, JoinAccept} from '@/Routes';
import TeamLeaveModal from './TeamLeaveModal.vue';
import FadingElement from '@/utils/FadingElement';
import { Deferred } from 'jquery';

import $ from 'jquery';

const modelSwitch = new ModelSwitch<TeamLists, TeamDto>((x, y) => x.refid === y.refid);

@Component({
    components: {TeamNewModal, TeamLeaveModal},
})
export default class TeamList extends Vue {

    get hasOwnedTeams(): boolean {
         return this.ownedTeams.length > 0;
    }
    public readonly id = '#team-list';

    public team: TeamDto | null = null;
    public budget: BudgetDto = BUDGET_DEFAULT;

    public openInvites: MutableList<InviteDto> = [];
    public fellowTeams: MutableList<TeamDto> = [];
    public ownedTeams: MutableList<TeamDto> = [];

    public hasHelpCard: boolean = false;
    public globalGlasspane: FadingElement;

    private afterUpdates: MutableList<JQueryDeferred<any>> = [];

    public mounted() {
      modelSwitch.register('team-own', '#team-own', '.list-group-item', 'data-team');
      modelSwitch.register('team-member', '#team-member', '.list-group-item', 'data-team');
      modelSwitch.register('team-invite', '#team-invite', '.list-group-item', 'data-invite');
      this.initializeLists().always(() => this.globalGlasspane.toggle(true));
    }

    public updated() {
        this.$nextTick(() => {
            this.afterUpdates.map((deferred) => deferred.resolve());
            this.afterUpdates = [];
        });
    }

    public initializeLists(): JQueryPromise<any> {
        const stop = Deferred();
        stop.reject();
        // Enumerate pane by pane and stop when we have something non-empty.
        // Start with invites
        return this.switchToInviteSelectionModel().then((invites) => {
            if (invites && invites.length > 0) {
                this.setActiveList('team-invite');
                return stop.promise();
            }
        }).then(this.switchToOwnSelectionModel).then((teams) => {
            // Continue with own teams
            if (teams && teams.length > 0) {
                this.setActiveList('team-own');
                return stop.promise();
            }
        }).then(this.switchToMemberSelectionModel).then((teams) => {
            // then with fellow teams
            if (teams && teams.length > 0) {
                this.setActiveList('team-member');
                return stop.promise();
            }
        }).then(this.switchToOwnSelectionModel).done(() => {
            // finally, if everything is empty, switch to own teams
            // and show Big Orange Button
            this.setActiveList('team-own');
            this.showHelpCard();
        });
    }

    public setActiveList(list: TeamLists) {
      $(`#tab-${list}`).tab('show');
      $("#nav-teams").find(".nav-link").removeClass("active");
      $(`#tab-${list}`).addClass("active");
    }

    public switchToOwnSelectionModel(): JQueryPromise<List<TeamDto>> {
        modelSwitch.switchTo('team-own');
        return this.showOwnedTeams();
    }

    public switchToMemberSelectionModel(): JQueryPromise<List<TeamDto>> {
        modelSwitch.switchTo('team-member');
        return this.showFellowTeams();
    }

    public switchToInviteSelectionModel(): JQueryPromise<List<InviteDto> | undefined> {
        modelSwitch.switchTo('team-invite');
        return this.showOpenInvites();
    }

    public setTeam(teamDto: TeamDto | null) {
        this.team = teamDto;
        const btnNewTeam = $('#teams-tab-row .btn-new-item');
        if (this.team) {
            // We have a selection => we have at least one team.
            // Show "New Team" button at the corner.
            this.budget = this.team.budget ? this.team.budget : BUDGET_DEFAULT;

            btnNewTeam.show();
            this.updateTeamData(this.team);
        } else {
            // Otherwise, we have no selection. This may happen when we're on invites tab,
            // and in this case we want to show regular "New Team" button anyway
            if (modelSwitch.current() !== modelSwitch.get('team-invite')) {
                btnNewTeam.hide();
            } else {
                btnNewTeam.show();
            }

            this.budget = BUDGET_DEFAULT;

            // Try showing the Big Orange Button
            this.showHelpCard();
        }
    }

    public updateTeamData(dto: TeamDto) {
        this.tryUpdateTeam(dto, 'ownedTeams');
        this.tryUpdateTeam(dto, 'fellowTeams');
    }

    public showOwnedTeams(): JQueryPromise<List<TeamDto>> {
        const promise = loadOwnedTeams().done(this.onLoadOwnedTeams);
        promise.fail((jqXhr) => {
            handleXhrError(jqXhr, 'Failed to load owned team list');
        });
        return promise;
    }

    public onNewTeamDashboardRefresh(team: TeamDto) {
        const loadOwnedPromise = loadOwnedTeams().done(this.onLoadOwnedTeams);
        const loadFellowPromise = loadParticipatedTeams().done(this.onLoadFellowTeams);
        const loading = {
                ownedPromise: loadOwnedPromise,
                fellowPromise: loadFellowPromise,
                team,
        };
        $.when(loading.ownedPromise, loading.fellowPromise).done(() => {
            const deferred = modelSwitch.current().setActiveAsync(loading.team);
            this.afterUpdates.push(deferred);
        });
    }

    public onEditTeamDashboardRefresh() {
        this.showOwnedTeams();
    }

    public onRemoveTeamDashboardRefresh() {
        this.showOwnedTeams().then(this.showFellowTeams);
    }

    ///////////////////////////////////////////////////////////////////////////
    // Dealing with fellow teams
    public showFellowTeams(): JQueryPromise<List<TeamDto>> {
        const promise = loadParticipatedTeams().done(this.onLoadFellowTeams);
        promise.fail((jqXhr) => {
            handleXhrError(jqXhr, 'Failed to load fellow team list');
        });
        return promise;
    }

    ///////////////////////////////////////////////////////////////////////////
    // Dealing with invites
    public showOpenInvites(): JQueryPromise<List<InviteDto> | undefined> {
        const promise = loadOpenInvites().then((invites) => {
            if (invites) {
                this.onLoadOpenInvites(invites);
            }
            return invites;
        });
        promise.fail((jqXhr) => {
            handleXhrError(jqXhr, 'Failed to load open invites');
        });
        return promise;
    }

    public joinTeam(code: string) {
        JoinAccept.invoke({ code })
            .then(this.showOpenInvites)
            .then((invites) => {
                // After joining the team, we either stay on invites tab (if we have more
                // invites) or switch to fellow teams (to show the team we just have joined).
                if (invites && invites.length === 0) {
                    this.setActiveList('team-member');
                    this.switchToMemberSelectionModel();
                }
            })
            .fail((jqXhr) => handleXhrError(jqXhr, 'Failed to join the team'));
    }

    public cancelInvitation(code: string) {
        CancelInvite.invoke({ code })
            .then(this.showOpenInvites)
            .then((invites) => {
                // If we have no invitations, we run the same procedure of enumerating
                // components as on landing (owned => fellow => invites => Big Button).
                if (invites && invites.length === 0) {
                    this.initializeLists();
                }
            })
            .fail((jqXhr) => handleXhrError(jqXhr, 'Fail to cancel invitation'));
    }


    public isOwnedTeam(refid: string): boolean {
        return this.ownedTeams.map((t) => t.refid).indexOf(refid) > -1;
    }

    private memberSelectionModel = (): SelectionModel<TeamDto> => modelSwitch.get('team-member');

    private ownSelectionModel = (): SelectionModel<TeamDto> => modelSwitch.get('team-own');

    private tryUpdateTeam(teamDto: TeamDto, list: string) {
        const idx = this[list].findIndex((t) => t.refid === teamDto.refid);
        if (idx > -1) {
            const team = this[list][idx];
            // because team that we own and team where we are a member can have different structure
            for (const k in teamDto) {
                if (team.hasOwnProperty(k)) {
                    team[k] = teamDto[k];
                }
            }
        }
    }

    private onLoadOwnedTeams(teams: List<TeamDto>) {
      this.ownedTeams = teams as MutableList<TeamDto>;
      this.loadTeamList(this.ownSelectionModel(), teams);
    }

    private loadTeamList(selectionModel: SelectionModel<TeamDto>,
                         loadedTeams: List<TeamDto>) {
        // We need to do it after Vue reconstructs DOM tree, otherwise we'll just have
        // no items in the list.
        const id2team = (id: string) => {
            return loadedTeams.find((t) => `${t.refid}` === `${id}`);
        };
        this.afterUpdates.push(selectionModel.init(id2team, updateDependencies));
        const deferred = Deferred();
        deferred.done(() => {
            this.showHelpCard();
        });
        this.afterUpdates.push(deferred);
    }

    private onLoadFellowTeams(teams: List<TeamDto>) {
        this.fellowTeams = teams as MutableList<TeamDto>;
        this.loadTeamList(this.memberSelectionModel(), teams);
    }

    private onLoadOpenInvites(invites: List<InviteDto>) {
        const selectionModel = modelSwitch.current();

        this.openInvites = invites as MutableList<InviteDto>;

        const id2InviteDto = (id: string) => {
            const openInvite = this.openInvites.find((ivt) => `${ivt.code}` === `${id}`);
            return openInvite ? openInvite.team : undefined;
        };

        this.afterUpdates.push(selectionModel.init(id2InviteDto, () => {}));
        this.afterUpdates.push(Deferred().always(() => updateDependencies(null)));
    }

    private showHelpCard() {
        this.hasHelpCard = (modelSwitch.current() !== modelSwitch.get('team-invite'))
            ? this.ownedTeams.length + this.fellowTeams.length === 0
            : false;
    }
}

</script>
